import {
  Component,
  Input,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { UserService } from 'src/app/core/api/user/user.service';
import { TranslationService } from 'src/app/core/services/translation/translation.service';
import { ProfileMenuItems } from '../../../models/profile-menu-items/profile-menu-items';
import { ProfileMenuComponent } from '../../molecules/profile-menu/profile-menu.component';
import { Region } from 'src/app/shared/models/dtos/region/region';

@Component({
  selector: 'app-desktop-header',
  templateUrl: './desktop-header.component.html',
  styleUrls: ['./desktop-header.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
/**
 * Logged user header
 */
export class DesktopHeaderComponent implements OnInit {
  @ViewChild(ProfileMenuComponent) userMenu!: ProfileMenuComponent;
  name?: string;
  regions!: Region[];
  @Input() profileMenuItems = new ProfileMenuItems();
  @Input() imgSource?: string;
  alt = 'uploaded-image-alt';
  labels = {
    role: 'admin',
  };

  /**
   * @constructor
   */
  constructor(
    private translationService: TranslationService,
    private readonly userService: UserService
  ) {}

  /**
   * onInit
   */
  ngOnInit(): void {
    this.translationService.translateObject(this.labels);
    this.translationService.translateString(this.alt).then((translated) => {
      this.alt = translated;
    });
    this.userService.getAdminInfo().subscribe((info) => {
      this.name = info.name;
      this.regions.push(...info.regions);
    });
  }
}
